import {Injectable} from '@angular/core';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {Individu} from '@Common/core/services';

@Injectable({ providedIn: 'root' })
export class IndividuDematService {
  private urlBase = `${environment.baseUrl}`;
  private url = `${this.urlBase}/demat/individu/`;
  constructor(private http: HttpClient) {}
  /**
   * Obtient ou créé un Individu
   * @param {string} uid : l'uid LDAP
   */
  getOrCreate(uid: string) {
    return this.http.get<Individu>(`${this.url}${uid}/get_or_create/`);
  }
}
